import { Button } from "primereact/button";

type BackToTopProps = {
  scroll: boolean;
};

const BackToTop: React.FC<BackToTopProps> = ({ scroll }) => {
  return (
    <>
      {scroll && (

        <Button onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} tooltip="Scroll to Top" tooltipOptions={{ position: 'top' }} className="scroll-to-target scroll-to-top">
          <span className="fas fa-arrow-up"></span>
        </Button>

        // <a href="#" className="scroll-to-target scroll-to-top">
        //   <i className="fas fa-arrow-up" />
        // </a>
      )}
    </>
  );
};

export default BackToTop;
